import { render } from "./PostFormView.vue?vue&type=template&id=209bd920"
import script from "./PostFormView.vue?vue&type=script&lang=js"
export * from "./PostFormView.vue?vue&type=script&lang=js"

import "./PostFormView.vue?vue&type=style&index=0&id=209bd920&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__